import React from "react";
import { connect } from "react-redux";
import "./_TextInputWithCharCount.scss";
import { updateActiveMemoryEngraving } from "../../redux/actions";

class TextInputWithCharCount extends React.Component {
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;

    this.props.updateActiveMemoryEngraving(value);
  };

  renderCharacterCount = (message) => {
    const length = message.length;
    return <span className="character-count">{length} / 30</span>;
  };

  render() {
    const {
      titleText,
      additionalClass,
      modalActiveMemoryEngraving,
    } = this.props;
    const containerClass = additionalClass
      ? `text-input-container ${additionalClass}`
      : "text-input-container";

    return (
      <div className={containerClass}>
        <span className="text-input-title">{titleText}</span>
        <input
          name="message"
          className="input-field"
          type="text"
          value={modalActiveMemoryEngraving}
          onChange={this.handleInputChange}
          maxLength="30"
        />
        {this.renderCharacterCount(modalActiveMemoryEngraving)}
      </div>
    );
  }
}

const mapStateToProps = ({ configuratorPageNecklace }) => {
  const { modalActiveMemoryEngraving } = configuratorPageNecklace;

  return {
    modalActiveMemoryEngraving,
  };
};

export default connect(mapStateToProps, {
  updateActiveMemoryEngraving,
})(TextInputWithCharCount);
